/**
 * Phase 5.4a (2026-05-15) — Hook React qui expose l'état du sync engine.
 * Voir `services/syncEngine.js`.
 */
import { useEffect, useState } from 'react';
import syncEngine from '../services/syncEngine';

export const useOfflineStatus = () => {
  const [state, setState] = useState(syncEngine.snapshot());
  useEffect(() => {
    const unsub = syncEngine.subscribe(setState);
    return unsub;
  }, []);
  return state;
};

export default useOfflineStatus;
